import ProductSearch from './search_component/product_search.js';
let productSearchContainer = '[data-product-search-container]';
if (document.querySelector(productSearchContainer)) {
    new ProductSearch();
}
